export default __webpack_public_path__ + "static/media/spotifyAn2.adb3d3cc.jpg";